import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.00003 11.0002H2.00003V18.0002C2.00003 19.1032 2.89703 20.0002 4.00003 20.0002H16C17.103 20.0002 18 19.1032 18 18.0002V11.0002H19C19.1978 11.0002 19.3911 10.9415 19.5555 10.8316C19.7199 10.7217 19.848 10.5656 19.9237 10.3829C19.9994 10.2002 20.0192 9.99912 19.9806 9.80517C19.942 9.61122 19.8468 9.43305 19.707 9.2932L10.707 0.293201C10.6142 0.200255 10.504 0.126518 10.3827 0.0762068C10.2614 0.0258961 10.1314 0 10 0C9.8687 0 9.73865 0.0258961 9.61734 0.0762068C9.49602 0.126518 9.38582 0.200255 9.29303 0.293201L0.293031 9.2932C0.153222 9.43305 0.0580152 9.61122 0.0194476 9.80517C-0.0191199 9.99912 0.000683092 10.2002 0.0763531 10.3829C0.152023 10.5656 0.280163 10.7217 0.444573 10.8316C0.608982 10.9415 0.802281 11.0002 1.00003 11.0002ZM8.00003 18.0002V13.0002H12V18.0002H8.00003ZM10 2.4142L16 8.4142L16.001 18.0002H14V13.0002C14 11.8972 13.103 11.0002 12 11.0002H8.00003C6.89703 11.0002 6.00003 11.8972 6.00003 13.0002V18.0002H4.00003V8.4142L10 2.4142Z",
		fill: "currentColor"
	})
});
export default SvgHome;
